import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=6d3ee0ea&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3ee0ea')) {
      api.createRecord('6d3ee0ea', component.options)
    } else {
      api.reload('6d3ee0ea', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=6d3ee0ea&", function () {
      api.rerender('6d3ee0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2caXOTsQKMPow/JS/cancellationPolicy.vue"
export default component.exports